// Projects.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { wp } from "../lib/wp";

// WP REST: tüm projeleri (gerekirse birden fazla sayfa) çek
async function fetchAllProjects() {
  const perPage = 100;
  let page = 1;
  let all = [];
  while (true) {
    const res = await fetch(
      wp(`/wp/v2/project?status=publish&per_page=${perPage}&page=${page}`)
    );
    if (!res.ok) break;
    const batch = await res.json();
    all = all.concat(batch);
    if (batch.length < perPage) break;
    page += 1;
  }
  return all;
}

const extractFirstImage = (htmlString) => {
  if (!htmlString) return null;
  const match = htmlString.match(/<img[^>]*?src="([^"]+)"/);
  return match ? match[1] : null;
};

const extractYear = (yearField) => {
  if (!yearField) return "Yıl bilinmiyor";
  const match = yearField.match(/\b(19|20)\d{2}\b/);
  return match ? match[0] : yearField;
};

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllProjects()
      .then(setProjects)
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-6 bg-[#F8F6ED] text-gray-800">
      <h2 className="text-3xl font-bold justify-center text-center mb-8 text-[#403f95]">
        PROJELER
      </h2>

      {/* 2 kolonlu grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {projects.map((project) => {
          const img =
            project.project_cover_image?.url ||
            extractFirstImage(project.project_description) ||
            "https://via.placeholder.com/600x400";
          const year = extractYear(project.project_year);
          const title = project.title?.rendered;

          return (
            <motion.div
              key={project.id}
              className="group cursor-pointer"
              onClick={() => navigate(`/project/${project.slug}`)}
              whileHover={{ y: -6, scale: 1.01 }}
              transition={{ duration: 0.25 }}
            >
              {/* Kart – Home.jsx ile aynı stil, #27285C uyumlu */}
              <div
                className={[
                  "relative bg-white p-4 rounded-xl",
                  "border border-[#252f91]", // 1. Değişiklik: Border rengi güncellendi.
                  "shadow-[0_10px_25px_rgba(39,40,92,0.25),0_2px_6px_rgba(39,40,92,0.15)]",
                  // 2. Değişiklik: Hover gölge rengi güncellendi (#5b5f83 -> rgba(91,95,131,...)).
                  "group-hover:shadow-[0_24px_60px_rgba(91,95,131,0.4),0_6px_14px_rgba(91,95,131,0.25)]",
                  "transition-all duration-300 ease-out",
                ].join(" ")}
              >
                <div className="overflow-hidden rounded-md">
                  <img
                    src={img}
                    alt={title}
                    className="w-full h-60 object-cover rounded-md transition-transform duration-300 group-hover:scale-[1.02]"
                  />
                </div>

                <div className="mt-3 text-center">
                  <p className="text-xs text-gray-500 uppercase tracking-wide">
                    {year}
                  </p>
                  <h3 className="text-sm font-semibold text-gray-800 mt-1 group-hover:text-[#1a365d] transition-colors">
                    {title}
                  </h3>
                </div>

                {/* zemine düşen ovall gölge */}
                <div className="pointer-events-none absolute inset-x-10 -bottom-3 h-6 rounded-full bg-[#27285C]/30 blur-xl opacity-50 group-hover:opacity-95 transition-opacity"></div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Projects;
